import { UserApi } from "../api/UserApi";
import { User } from "../models/User";

export default class UserUtils {
    static isAdmin(): Promise<boolean> {
        const userApi = new UserApi();
        return userApi.getCurrentUser().then((user) => {
            if (!user) {
                return false;
            }
            return user.isAdmin;
        });
    }

    /** Accès bureau (admin ou utilisateur bureau), cf. User::hasWebAccess(). */
    static hasWebAccess(): Promise<boolean> {
        const userApi = new UserApi();
        return userApi.getCurrentUser().then((user) => {
            if (!user) {
                return false;
            }
            return user.isAdmin || user.hasRole(User.ERole.DesktopUser);
        });
    }
}
